import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointsSiteCell } from './charge-points-site.cell';
import { ChargePointsSiteHeader } from './charge-points-site.header';

export const ChargePointsSiteColumn: IdentifiedColumnDef<
  GatewayChargePointInMaintenanceModel,
  GatewayChargePointInMaintenanceModel['location']
> = {
  enableSorting: false,
  header: ChargePointsSiteHeader,
  cell: ChargePointsSiteCell,
};
